<script>
/**
 * ****************************************************************************
 * @description     :   Main component for popup MST_012
 * @created at      :   2026/01/23
 * @created by      :   longvv
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

import store from '@/store';
import template from './template.html';
import { mapState, mapMutations, mapActions } from 'vuex';
import PopupMST012 from '@/views/popupSearch/PopupMST012/store';
import helpers from '@/utils/helpers';

var PopupMST012Index = {
    template: template,
    props: {
        onSelected: Function,
        id: String,
        initData: [String, Number, Object],
        isShowFooter: Boolean
    },
    beforeCreate() {
        if (!store.hasModule('PopupMST012')) {
            store.registerModule('PopupMST012', PopupMST012);
        }
    },
    created() {
        this.onInitScreen();
        this.applyInitData();
        this.onSearchItem();
    },
    data() {
        return {};
    },
    emits: ['close', 'onReferModelValue', 'onReferValueName'],
    computed: {
        ...mapState('PopupMST012', ['listData', 'data', 'totalRows', 'msgNoData'])
    },
    methods: {
        ...mapMutations('app', ['showHeaderError', 'showModalMessage']),
        ...mapActions('PopupMST012', ['searchBankInfo']),
        ...mapMutations('PopupMST012', ['resetDataInit', 'setPageNavigation', 'setPageNo']),
        applyInitData() {
            if (this.initData && typeof this.initData === 'object') {
                if (this.initData.bank_cd !== undefined) {
                    this.data.bank_cd = this.initData.bank_cd;
                }
            } else if (this.initData !== undefined && this.initData !== null) {
                this.data.bank_cd = this.initData;
            }
        },
        onSearchItem() {
            this.setPageNavigation({
                currentPage: 1,
                perPage: this.data.pageSize
            });
            this.searchBankInfo(this.data);
        },
        changeCurrentPage(data) {
            this.data.pageNo = data.currentPage;
            this.data.pageSize = data.perPage;
            this.searchBankInfo(this.data);
        },
        onInitScreen() {
            helpers.removeAllRequireInput();
            this.resetDataInit();
        },
        chooseItem(item) {
            this.$emit('onReferModelValue', item.bank_cd);
            this.$emit('onReferValueName', item.bank_name);
            this.$emit('close');
        }
    }
};
export default PopupMST012Index;
</script>

<style lang="scss">
@use '@/assets/scss/common/popup.scss' as *;
</style>
